/**
 * Directive: resourceRequestTime
 */
angular.module('acme.common.directive.resourceRequestTime', [])
.directive('resourceRequestTime', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/resourceRequest/time/time.tpl.html',
      scope: {
        type: '@',
        preset: '@',
        model: '=',
        schedule: '=?'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.resourceRequestTime = {

          model: {
            start: {
              timeFrame: '',
              allocation: '',
              type: '',
              duration: {
                hour: 1,
                minutes: 0
              }
            },
            end: {
              timeFrame: '',
              allocation: '',
              type: '',
              duration: {
                hour: 1,
                minutes: 0
              }
            }
          },

          hideEndChoices: false,
          disableEndAllocationDisable: false,
          showEndDuration: false,
          showStartDuration: false,

          endTimeFrames: [],
          startTimeFrames: [],

          endAllocations: [],
          startAllocations: [],

          timeFrames: [
            {
              type: 'before',
              label: 'Before'
            },
            {
              type: 'when',
              label: 'When'
            },
            {
              type: 'after',
              label: 'After'
            },
            {
              type: 'duration',
              label: 'Duration'
            }
          ],

          privateTimeFrames: [
            {
              type: 'every',
              label: 'Every'
            },
            {
              type: 'first',
              label: 'First'
            },
            {
              type: 'last',
              label: 'Last'
            }
          ],

          allocations: [
            {
              type: 'first',
              label: 'First instance'
            },
            {
              type: 'every',
              label: 'Every instance'
            },
            {
              type: 'last',
              label: 'Last instance'
            }
          ],

          types: [
            {
              type: 'starts',
              label: 'Starts'
            },
            {
              type: 'ends',
              label: 'Ends'
            }
          ],

          start: {
            hours: 1,
            minutes: 0
          },

          end: {
            hours: 1,
            minutes: 0
          },

          init: function() {
            this.startTimeFrames = this.getStartTimeFrames();
            this.endTimeFrames = this.getEndTimeFrames();
            this.startAllocations = this.getStartAllocations($scope.preset);
            this.endAllocations = this.getEndAllocations();
            this.setDefaults();

          },

          setDefaults: function() {
            if ($scope.model) {
              this.model.start.timeFrame = this.startTimeFrames[this.findStartTimeFrame($scope.model.start.timeFrame).index];
              this.model.start.allocation = this.startAllocations[this.findStartAllocation($scope.model.start.allocation).index];
              this.model.start.type = this.types[this.findType($scope.model.start.type).index];
              this.model.start.duration.hour = $scope.model.start.duration.hour;
              this.model.start.duration.minutes = $scope.model.start.duration.minutes;

              this.model.end.timeFrame = this.endTimeFrames[this.findEndTimeFrame($scope.model.end.timeFrame).index];
              this.model.end.allocation = this.endAllocations[this.findEndAllocation($scope.model.end.allocation).index];
              this.model.end.type = this.types[this.findType($scope.model.end.type).index];
              this.model.end.duration.hour = $scope.model.end.duration.hour;
              this.model.end.duration.minutes = $scope.model.end.duration.minutes;
            }else{
              switch($scope.preset) {
                case 'setup':
                  this.model.start.timeFrame = this.startTimeFrames[0];
                  this.model.start.allocation = this.startAllocations[0];
                  this.model.start.type = this.types[0];

                  this.model.end.timeFrame = this.endTimeFrames[3];
                  this.model.end.allocation = this.endAllocations[0];
                  this.model.end.type = this.types[1];
                  break;
                case 'cleanup':
                  this.model.start.timeFrame = this.startTimeFrames[2];
                  this.model.start.allocation = this.startAllocations[0];
                  this.model.start.type = this.types[1];

                  this.model.end.timeFrame = this.endTimeFrames[3];
                  this.model.end.allocation = this.endAllocations[0];
                  this.model.end.type = this.types[1];
                  break;
                case 'event':
                  /* falls through */
                default:
                  this.model.start.timeFrame = this.startTimeFrames[1];
                  this.model.start.allocation = this.startAllocations[1];
                  this.model.start.type = this.types[0];

                  this.model.end.timeFrame = this.endTimeFrames[1];
                  this.model.end.allocation = this.endAllocations[1];
                  this.model.end.type = this.types[1];
              }

            }

            this.updateOptions();

          },

          isPreset: function(preset) {
            return ($scope.preset === preset);
          },

          isType: function(type) {
            return ($scope.type === type);
          },

          isPrivateSchedule: function() {
            return ($scope.schedule.type === 'private');
          },

          isRepeating: function() {

            var r = true;

            if (
              $scope.schedule &&
              $scope.schedule.repeatCycle === 'never' &&
              !this.isPrivateSchedule()
            ) {
              r = false;
            }

            return r;

          },

          getPresetLayout: function() {
            return 'common/directives/resourceRequest/time/' + $scope.preset + '.tpl.html';
          },

          toggleSchedule: function() {
            this.showSchedule = !this.showSchedule;
            $scope.$emit('ResourceRequest::ToggleSchedule', { showSchedule: this.showSchedule });
          },

          updateOptions: function() {

            var found;

            if (this.model.start.timeFrame.type === 'before' ||
                this.model.start.timeFrame.type === 'after') {
              this.showStartDuration = true;
            }else{
              this.showStartDuration = false;
            }

            if (this.model.end.timeFrame.type === 'before' ||
                this.model.end.timeFrame.type === 'after') {
              this.showEndDuration = true;
              this.hideEndChoices = false;
            }else if (this.model.end.timeFrame.type === 'duration') {
              this.showEndDuration = true;
              this.hideEndChoices = true;
            }else{
              this.showEndDuration = false;
              this.hideEndChoices = false;
            }

            if (this.model.start.allocation.type === 'every') {
              this.endAllocations = [this.allocations[1]];
              this.model.end.allocation = this.endAllocations[0];
              this.disableEndAllocationDisable = true;
            }else if (this.model.start.allocation.type === 'last') {
              this.endAllocations = [this.allocations[2]];
              this.model.end.allocation = this.endAllocations[0];
              this.disableEndAllocationDisable = true;
            }else{

              this.endAllocations = [this.allocations[0], this.allocations[2]];

              found = this.findEndAllocation(this.model.end.allocation.type);

              if (found) {
                this.model.end.allocation = this.endAllocations[found.index];
              }else{
                this.model.end.allocation = this.endAllocations[0];
              }

              this.disableEndAllocationDisable = false;

            }

            this.updateModel();

          },

          updateModel: function() {

            if (!$scope.model) {
              $scope.model = {
                start: {
                  allocation: this.model.start.allocation.type,
                  timeFrame: this.model.start.timeFrame.type,
                  type: this.model.start.type.type,
                  duration: {
                    hour: this.model.start.duration.hour,
                    minutes: this.model.start.duration.minutes
                  }
                },
                end: {
                  allocation: this.model.end.allocation.type,
                  timeFrame: this.model.end.timeFrame.type,
                  type: this.model.end.type.type,
                  duration: {
                    hour: this.model.end.duration.hour,
                    minutes: this.model.end.duration.minutes
                  }
                }
              };
            }else {

              if ($scope.model.end) {
                $scope.model.end.allocation = this.model.end.allocation.type;
                $scope.model.end.timeFrame = this.model.end.timeFrame.type;
                $scope.model.end.type = this.model.end.type.type;
                $scope.model.end.duration.hour = this.model.end.duration.hour;
                $scope.model.end.duration.minutes = this.model.end.duration.minutes;
              }

              if ($scope.model.start) {
                $scope.model.start.allocation = this.model.start.allocation.type;
                $scope.model.start.timeFrame = this.model.start.timeFrame.type;
                $scope.model.start.type = this.model.start.type.type;
                $scope.model.start.duration.hour = this.model.start.duration.hour;
                $scope.model.start.duration.minutes = this.model.start.duration.minutes;
              }
            }

          },

          findStartTimeFrame: function(type) {
            var i, ii,
                r = false;

            for (i=0,ii=this.startTimeFrames.length;i<ii;i++) {
              if (this.startTimeFrames[i].type === type) {
                r = {
                  timeFrame: this.startTimeFrames[i],
                  index: i
                };
                break;
              }
            }

            return r;
          },

          findStartAllocation: function(type) {
            var i, ii,
                r = false;

            for (i=0,ii=this.startAllocations.length;i<ii;i++) {
              if (this.startAllocations[i].type === type) {
                r = {
                  allocation: this.startAllocations[i],
                  index: i
                };
                break;
              }
            }

            return r;

          },

          findEndTimeFrame: function(type) {
            var i, ii,
                r = false;

            for (i=0,ii=this.endTimeFrames.length;i<ii;i++) {
              if (this.endTimeFrames[i].type === type) {
                r = {
                  timeFrame: this.endTimeFrames[i],
                  index: i
                };
                break;
              }
            }

            return r;
          },

          findEndAllocation: function(type) {
            var i, ii,
                r = false;

            for (i=0,ii=this.endAllocations.length;i<ii;i++) {
              if (this.endAllocations[i].type === type) {
                r = {
                  allocation: this.endAllocations[i],
                  index: i
                };
                break;
              }
            }

            return r;
          },

          findTimeFrame: function(type) {
            var i, ii,
                r = false;

            for (i=0,ii=this.timeFrames.length;i<ii;i++) {
              if (this.timeFrames[i].type === type) {
                r = {
                  timeFrame: this.timeFrames[i],
                  index: i
                };
                break;
              }
            }

            return r;
          },

          findAllocation: function(type) {
            var i, ii,
                r = false;

            for (i=0,ii=this.allocations.length;i<ii;i++) {
              if (this.allocations[i].type === type) {
                r = {
                  allocation: this.allocations[i],
                  index: i
                };
                break;
              }
            }

            return r;
          },

          findType: function(type) {
            var i, ii,
                r = false;

            for (i=0,ii=this.types.length;i<ii;i++) {
              if (this.types[i].type === type) {
                r = {
                  type: this.types[i],
                  index: i
                };
                break;
              }
            }

            return r;
          },

          getStartTimeFrames: function() {
            return this.timeFrames.slice(0, 3);
          },

          getEndTimeFrames: function() {
            return this.timeFrames.slice(0);
          },

          getStartAllocations: function(preset) {
            var r;

            switch(preset) {
              case 'setup':
                r = [
                  this.allocations[0],
                  this.allocations[1]
                ];
                break;
              case 'cleanup':
                r = [
                  this.allocations[2],
                  this.allocations[1]
                ];
                break;
              case 'event':
                /* falls through */
              default:
                r = this.allocations.slice(0);
            }

            return r;
          },

          getEndAllocations: function() {
            return this.allocations.slice(0);
          }

        };

        $scope.resourceRequestTime.init();

      }]

    };

}]);